import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import styled from 'styled-components';
import KenIcon from '../KenIcon';
import ErrorIcon from '../../Assets/Icons/error.png';

const StyledBox = styled(Box)((theme) => ({
  color: '#FC2C32',
}));
export default function KenError({ errors, field, type, message, single }) {
  if (single && message) {
    return (
      <StyledBox component="span">
        <Box height="16px" margin="19px 8px" alignItems={'center'} display={'flex'}>
            <KenIcon iconType="img" icon={ErrorIcon} variant="extraSmall"></KenIcon> &nbsp;&nbsp;
            <Typography fontSize={'12px'} marginTop={'4px'}>
              {message || 'Please enter valid input'}
            </Typography>
        </Box>
      </StyledBox>
    );
  }

  return (
    <StyledBox component="span">
      <Typography>
        {errors[field] && errors[field]?.type === type ? message : ''}
      </Typography>
    </StyledBox>
  );
}
